export default {
  "Pessoa Física": 1,
  "Pessoa Jurídica": 2
};
